import parse from 'html-react-parser'
import React, { FC, useCallback, useEffect, useState } from 'react'
import { Header } from '../../components/header'
import { Steps } from '../../components/steps'

export type Props = {
  goNextStep: (mountingHoles: string, undersideLip: string) => void
  goBackStep: () => void
}

export const Step_4: FC<Props> = ({ goNextStep, goBackStep }) => {
  const [mountingHoles, setMountingHoles] = useState<string>('')
  const [undersideLip, setUndersideLip] = useState<string>('')
  const [showButton, setShowButton] = useState<boolean>(false)

  const dataItem = document.getElementById('custom-sizes-step-4')
  const data = dataItem !== null ? JSON.parse(dataItem.innerText) : null

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    if (mountingHoles !== '' && undersideLip !== '') {
      setShowButton(true)
    } else {
      setShowButton(false)
    }
  }, [mountingHoles, undersideLip])

  if (data == null) {
    return null
  }

  function changeMountingHoles(e: string) {
    setMountingHoles(e)
  }

  function changeUndersideLip(e: string) {
    setUndersideLip(e)
  }

  function goNext() {
    goNextStep(mountingHoles, undersideLip)
  }

  const goBack = useCallback(() => {
    goBackStep()
  }, [goBackStep])

  return (
    <div className="CS_Step4">
      <Steps step={4} allSteps={5} />
      {data.header && <Header text={data.header} />}

      <div className="CS_Step4-grid">
        <div className="CS_Step4-item">
          <div className="CS_Step4-header">
            <span className="CS_Step4-title">{data.title_mounting_holes}</span>
            <span className="CS_Step4-subtitle">
              {data.subtitle_mounting_holes}
            </span>
          </div>

          {/* Image */}
          <div className="CS_Step4-imageBg">
            <div
              className="CS_Step4-image"
              style={{ backgroundImage: `url(${data.image_mounting_holes})` }}
            ></div>
          </div>

          {/* Text */}
          <div className="CS_Step4-text">{parse(data.text_mounting_holes)}</div>

          {/* Radio */}
          <div className="CS_Step4-radioContainer">
            <div
              className={`CS_Step4-radio ${
                mountingHoles === 'Yes' ? 'active' : ''
              }`}
              onClick={() => changeMountingHoles('Yes')}
              tabIndex={0}
            >
              Yes
            </div>
            <div
              className={`CS_Step4-radio ${
                mountingHoles === 'No' ? 'active' : ''
              }`}
              onClick={() => changeMountingHoles('No')}
              tabIndex={0}
            >
              No
            </div>
          </div>
        </div>

        <div className="CS_Step4-item">
          <div className="CS_Step4-header">
            <span className="CS_Step4-title">{data.title_underside_lip}</span>
            <span className="CS_Step4-subtitle">
              {data.subtitle_underside_lip}
            </span>
          </div>

          {/* Image */}
          <div className="CS_Step4-imageBg">
            <div
              className="CS_Step4-image"
              style={{ backgroundImage: `url(${data.image_underside_lip})` }}
            ></div>
          </div>

          {/* Text */}
          <div className="CS_Step4-text">{parse(data.text_underside_lip)}</div>

          {/* Radio */}
          <div className="CS_Step4-radioContainer">
            <div
              className={`CS_Step4-radio ${
                undersideLip === 'Yes' ? 'active' : ''
              }`}
              onClick={() => changeUndersideLip('Yes')}
              tabIndex={0}
            >
              Yes
            </div>
            <div
              className={`CS_Step4-radio ${
                undersideLip === 'No' ? 'active' : ''
              }`}
              onClick={() => changeUndersideLip('No')}
              tabIndex={0}
            >
              No
            </div>
          </div>
        </div>
      </div>

      <div className="CS_Step4-btnContainer">
        <button className="GoBack" onClick={goBack}>
          <svg
            width="16"
            height="10"
            viewBox="0 0 16 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.75 5L1.25 5M1.25 5L5.54032 0.999999M1.25 5L5.54032 9"
              stroke="#4E6280"
              stroke-width="1.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Back
        </button>
        {showButton === true && (
          <button
            className="o-button o-button--blue CS_Step4-btn"
            onClick={goNext}
          >
            Next
          </button>
        )}
      </div>
    </div>
  )
}
